import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { Container, Collapse, Button } from 'reactstrap';
import { mind_pattern_sections } from '../../../core/constants'
import { Checkbox } from '../common'
import { StepProgress } from './step-progress';

const AssessmentPartTwo = (props) => {

  const { hanndleNext, question_key, questions, selected_options, current_step, hanndlePrev } = props;

  const [current_value, setCurrentValue] = useState(null);

  useEffect(() => {
    setCurrentValue(null);
  }, [current_step]);

  const [collapseStates, setCollapseStates] = useState({});
  const toggleCollapse = (id) => {
    setCollapseStates((prevState) => ({
      ...prevState,
      [id]: !prevState[id],
    }));
  };

  const toggle = (value) => {
    setCurrentValue(value)
  };

  let next = mind_pattern_sections.REPORT
  if (selected_options.size < 2) {
    next = mind_pattern_sections.ASSESSMENT_PART_TWO
  }

  const select_option_chbox = new Set([current_value])

  const items = questions.map(item => {

    const item_selected = selected_options.find(s_item => s_item === item.code)
    if (item_selected || selected_options.size === 2) {
      return null
    }

    return (
      <div key={item.id} className='border rounded-lg p-2 mb-3'>
        <div className={`d-flex align-items-center`}>
          <Checkbox handleCheckboxChange={toggle} select_option={select_option_chbox} label='' value={item.code} type={'radio'} />

          <div id={`toggler${item.id}`} onClick={() => toggleCollapse(item.id)} className="cursor-pointer flex-fill d-flex align-items-center">
            {item.icon && <span className="ico mr-3"><img src={item.icon} alt={item.name} width="44" height="44" /></span>}
            <p className='mb-0 h3 d-inline text-capitalize flex-fill'>{item.name.toLowerCase()}</p>
            <i className={`icon ${collapseStates[item.id] ? 'flip-180' : ''}`}>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill='currentColor'>
                <path className="st0" d="M20,9.5L12.5,17c-0.1,0.1-0.2,0.1-0.2,0.2c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0-0.2,0-0.3-0.1c-0.1,0-0.2-0.1-0.2-0.2
              L4,9.5C3.8,9.4,3.8,9.2,3.8,9c0-0.2,0.1-0.4,0.2-0.5c0.1-0.1,0.3-0.2,0.5-0.2c0.2,0,0.4,0.1,0.5,0.2l7,7l7-7
              c0.1-0.1,0.2-0.1,0.2-0.2c0.1,0,0.2-0.1,0.3-0.1c0.1,0,0.2,0,0.3,0.1c0.1,0,0.2,0.1,0.2,0.2c0.1,0.1,0.1,0.2,0.2,0.2
              c0,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.2-0.1,0.3C20.2,9.4,20.1,9.5,20,9.5z"/>
              </svg>
            </i>
          </div>
        </div>
        <Collapse isOpen={collapseStates[item.id]} className={`list-${item.name.toLowerCase()}`}>
          <div className="styled-list pl-lg-5" dangerouslySetInnerHTML={{ __html: item[`description_step${current_step}`] }}>
          </div>
        </Collapse>
      </div>
    )
  })

  return (
    <div className='w-100 h-100'>
      <Container fluid="md" className='mx-auto h-100 px-0'>
        {selected_options.size < 2 && <div className='py-md-3 px-md-3 rounded border-md h-100'>
          <StepProgress currentStep={1} />
          
          <h1 className='mb-2 libre-caslon-text-regular h3-md h4'>Mind Patterns</h1>
          <p className='mb-3'>Read the characteristics of each card and select the one that most describes you</p>
          <div>
            {items}
          </div>
          <div className='text-center'>
            {((questions.size - 1) === current_step) && (selected_options.size === 1) ?
              <Button size="sm" onClick={() => { hanndleNext(next, null, current_value, mind_pattern_sections.ASSESSMENT_PART_TWO) }} color={(!current_value ? 'outline-green-light' : 'green-light')} disabled={!current_value}>
                <i class="bi bi-list-check mr-2">
                  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" fill='currentColor' viewBox="0 0 15 14" style={{ marginBottom: '1px' }}>
                    <path d="M13.2,4.4l-7,7c-0.1,0.1-0.1,0.1-0.2,0.1c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0-0.2,0-0.3-0.1c-0.1,0-0.2-0.1-0.2-0.1
                  L2.2,8.3C2.2,8.3,2.1,8.2,2.1,8.1C2,8,2,8,2,7.9c0-0.1,0-0.2,0.1-0.3c0-0.1,0.1-0.2,0.1-0.2c0.1-0.1,0.1-0.1,0.2-0.1
                  c0.1,0,0.2-0.1,0.3-0.1c0.1,0,0.2,0,0.3,0.1c0.1,0,0.2,0.1,0.2,0.1L5.7,10l6.5-6.5c0.1-0.1,0.3-0.2,0.5-0.2c0.2,0,0.3,0.1,0.5,0.2
                  c0.1,0.1,0.2,0.3,0.2,0.5C13.4,4.1,13.3,4.3,13.2,4.4L13.2,4.4z"/>
                  </svg>
                </i>
                Finish
              </Button>
              :
              <Button size="sm" onClick={() => hanndleNext(next, null, current_value, mind_pattern_sections.ASSESSMENT_PART_TWO)} color={(!current_value ? 'outline-green-light' : 'green-light')} disabled={!current_value}>
                <i className='mr-2'>
                  <svg xmlns="http://www.w3.org/2000/svg" style={{ marginBottom: '2px' }} width="11" height="10" fill="currentColor" viewBox="0 0 10.94 9.19">
                    <path d="M10.75,5.06l-3.94,3.94c-.12,.12-.29,.19-.46,.19s-.34-.07-.46-.19c-.12-.12-.19-.29-.19-.46s.07-.34,.19-.46l2.82-2.82H.66c-.17,0-.34-.07-.46-.19-.12-.12-.19-.29-.19-.46s.07-.34,.19-.46c.12-.12,.29-.19,.46-.19H8.7L5.88,1.12c-.12-.12-.19-.29-.19-.46s.07-.34,.19-.46,.29-.19,.46-.19,.34,.07,.46,.19l3.94,3.94c.06,.06,.11,.13,.14,.21s.05,.17,.05,.25c0,.09-.02,.17-.05,.25-.03,.08-.08,.15-.14,.21Z" />
                  </svg>
                </i>
                Next
              </Button>
            }
          </div>
        </div>}
      </Container>
    </div>
  )

}

const mapStateToProps = (state, props) => {
  return {};
};

const mapDispatchToProps = {
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AssessmentPartTwo)
